import { createContext, useContext, useRef, useEffect, useState } from "react";

const MapObjectsContext = createContext(null);

export function MapObjectsProvider({ children }) {
  const [mapObjects, setMapObjects] = useState([]);
  const mapObjectsRef = useRef(mapObjects);

  useEffect(() => {
    mapObjectsRef.current = mapObjects;
  }, [mapObjects]);

  return (
    <MapObjectsContext.Provider
      value={{
        mapObjectsRef,
        mapObjects,
        setMapObjects,
      }}
    >
      {children}
    </MapObjectsContext.Provider>
  );
}

export function useMapObjects() {
  return useContext(MapObjectsContext);
}
